import { TranslationObject } from '@/types/language';

const frenchTranslations: TranslationObject = {
  // Home Screen
  'welcome': 'Bienvenue au Musée',
  'select_tour': 'Sélectionner une visite',
  'search_exhibit': 'Rechercher une exposition',
  'visitor_info': 'Informations visiteurs',
  
  // Tour Selection
  'available_tours': 'Visites disponibles',
  'view_all_tours': 'Voir toutes les visites',
  
  // Exhibit Access
  'exhibit_access': 'Accéder à une exposition',
  'enter_number': 'Entrer le numéro d\'exposition',
  'scan_qr': 'Scanner le code QR',
  'view_map': 'Voir sur la carte',
  'browse_exhibits': 'Parcourir les expositions',
  'keypad': 'Clavier',
  'browse_tours': 'Parcourir les visites',
  
  // Exhibit Detail
  'add_to_favorites': 'Ajouter aux favoris',
  'remove_from_favorites': 'Retirer des favoris',
  'share': 'Partager',
  'previous': 'Précédent',
  'next': 'Suivant',
  'audio_guide': 'Guide audio',
  'more_info': 'Plus d\'informations',
  
  // Favorites
  'favorites': 'Favoris',
  'no_favorites': 'Pas encore de favoris. Ajoutez des expositions pendant votre visite !',
  
  // Visitor Info
  'opening_hours': 'Heures d\'ouverture',
  'getting_here': 'Comment venir',
  'contact': 'Contactez-nous',
  'important_links': 'Liens importants',
  
  // Accessibility
  'accessibility': 'Accessibilité',
  'font_size': 'Taille de police',
  'font_size_normal': 'Normal',
  'font_size_large': 'Grand',
  'font_size_extra_large': 'Très grand',
  'high_contrast': 'Contraste élevé',
  'language': 'Langue',
  'select_language': 'Sélectionner la langue',
  'accessibility_menu': 'Options d\'accessibilité',
  'toggle_high_contrast': 'Basculer le mode contraste élevé',
  'audio_controls': 'Contrôles audio',
  'playback_speed': 'Vitesse de lecture',
  'volume': 'Volume',
  'auto_play_audio': 'Lecture automatique de l\'audio',
  'toggle_auto_play': 'Basculer la lecture automatique',
  
  // Navigation
  'home': 'Accueil',
  'tours': 'Visites',
  'exhibits': 'Expositions',
  'info': 'Info',
  'map': 'Carte',
  'list': 'Liste',
  
  // General
  'loading': 'Chargement...',
  'error': 'Une erreur s\'est produite',
  'back': 'Retour',
  'play': 'Jouer',
  'pause': 'Pause',
  
  // Search related translations
  'search': 'Rechercher...',
  'no_results': 'Aucun résultat trouvé',
  
  // Welcome Message
  'welcome_message': 'Bienvenue dans l\'application de visite audio du Musée Agam. Vous pouvez explorer nos expositions en saisissant un numéro à l\'aide du clavier, ou naviguer à travers des visites guidées à partir du menu.',
};

export default frenchTranslations;
